import React from 'react'
import Premium from '../../components/Navbar/Premium'

function PremiumPage() {
  return (
    <><Premium/></>
  )
}

export default PremiumPage